<div class="wrapper">
    <app-header></app-header>
    <main>
        <div class="app-content">
            <router-outlet></router-outlet>
        </div>
    </main>
    <app-footer></app-footer>
</div>